<template>
  <footer class="footer px-4">
    <b-row align-v="center" class="justify-content-lg-between">
      <b-col lg="6">
        <div class="copyright text-center text-muted">
          © {{year}} INEXLINK
        </div>
      </b-col>
      
    </b-row>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style>
.footer .row{
  width: 100%;
}
.footer .row .col-lg-6{
margin: 0 auto;
}
footer.footer.px-4 {
    bottom: 0;
    width: 80%;
}

</style>
